import {
  Component,
  OnInit,
  OnDestroy,
  Inject,
  AfterViewInit,
  ChangeDetectorRef
} from '@angular/core';
import * as OktaSignIn from '@okta/okta-signin-widget';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';
import '@okta/okta-signin-widget/dist/css/okta-sign-in.min.css';
import {
  AppDataService,
  GlobalVariablesService,userFeatureRequest
} from '@tmhcc-ng-lib/data-service';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { CustomModalComponent } from 'libs/artisan-edge/src/lib/custom-modal/custom-modal.component';
import { ForgetPasswordComponent } from 'libs/artisan-edge/src/lib/forget-password/forget-password.component';
import { DialogService, DialogConfig } from '@tmhcc-ng-lib/framwork/dialog';
import {
  LoginContentService,
  ResetPasswordService,
  ForgotPasswordService
} from '@tmhcc-ng-lib/content-service';
import { LoginSitecoreContent } from 'libs/content-service/def/login-content';
import { OktaLoginRequest } from '@tmhcc-ng-lib/data-service';
import { appendRelativePathToUrl, getBaseUrl } from '@tmhcc/util';
import { OktaConfig2 } from '..';
import { OktaAuthService, OktaConfig, OKTA_CONFIG } from '@okta/okta-angular';
import { ResetPasswordComponent } from 'libs/artisan-edge/src/lib/reset-password/reset-password.component';
import { BASE_URI } from 'libs/startup/tokens/base-uri.token';
import { Router } from '@angular/router';
import { IsTrue } from 'libs/util/binary-util';
import { AlertTosterService } from '@tmhcc/framwork/alert-toster';
import { OktaLoginService } from '@tmhcc-ng-lib/okta-service';

declare var $: any;

@Component({
  selector: 'app-secure',
  templateUrl: './okta-login.component.html',
  styleUrls: ['./okta-login.component.scss']
})
export class OktaLoginComponent implements OnInit, OnDestroy, AfterViewInit {
  trustedMediaUrl;
  mediaURL = '';
  oktaSignIn;
  token;
  page: any;
  isDataAvailable: boolean = false;
  modalContent: DialogConfig = this.loginContentService.oktaErrorModal();
  resetPasswordModalContent: DialogConfig = this.resetPasswordService.resetPasswordModal();
  forgetPasswordModalContent: DialogConfig = this.forgotPasswordService.forgotPasswordModal();
  loginData: LoginSitecoreContent;
  signIn;
  isLoading: boolean;

  titleText: string;
  constructor(
    private crd: ChangeDetectorRef,
    private oktaAuth: OktaAuthService,
    private sanitizer: DomSanitizer,
    protected configService: AppConfigService,
    private loaderService: LoaderService,
    public dialogService: DialogService,
    private appDataService: AppDataService,
    private loginContentService: LoginContentService,
    private forgotPasswordService: ForgotPasswordService,
    private resetPasswordService: ResetPasswordService,
    private oktaLoginService: OktaLoginService,
    private router: Router,
    private titleService: Title,
    private alertService: AlertTosterService,
    private globalVariables: GlobalVariablesService,

    @Inject(OKTA_CONFIG) protected config: OktaConfig,
    @Inject(BASE_URI) private baseUri: string
  ) {
    this.signIn = oktaAuth;
    setTimeout(() => this.customSignInField(), 500);
    this.loaderService.isLoading.subscribe(loader => {
      setTimeout(() => {
        this.isLoading = loader;
      }, 200);
    });
    this.loaderService.show();
  }

  ngOnInit() {
    let windowOBJ=window as any;
    if(windowOBJ.hideBoostAI){
      windowOBJ.hideBoostAI();
    }
   this.titleService.setTitle('Artisan :: Login');

    if (this.oktaSignIn) this.oktaSignIn.remove();

    this.loginContentService.data$.subscribe(res => {
      this.loginContent(res);
      this.appDataService.logoutMsg.next(res.messages[0].description);
    });

    const windowUrl = window.location.href;
    let isReset = windowUrl.includes('reset');
    if (isReset) {
      this.resetPasswordModal();
    } else {
    }
    //this.router.navigate(['/login']);
  }
  checkElementAvailbility() {
    const nodeList = document.querySelectorAll('a[data-se = "signout-link"]');
    if (!nodeList.length) {
      setTimeout(() => {
        this.checkElementAvailbility();
      }, 100);
      return;
    }
    if (nodeList.length) {
      (<any>nodeList[0]).onclick = () => {
        this.showCustomOktaForm();
      };
    }
  }

  showCustomOktaForm() {
    setTimeout(() => {
      let userName = window.document.getElementsByClassName(
        'o-form-input-name-username'
      );
      if (!userName.length) {
        this.showCustomOktaForm();
        return;
      }
      this.customSignInField();
    }, 500);
  }

  loginContent(data) {
    if (data) {
      this.loaderService.hide();
      this.loginData = data;
      this.isDataAvailable = true;
      const iframURL = this.loginData.media[0].navigation.Url;
      this.trustedMediaUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        iframURL
      );
      this.mediaURL = this.trustedMediaUrl;
    }
  }
  async ngAfterViewInit() {
    const authenticated = await this.oktaAuth.isAuthenticated();
    const loginUrl = `${this.configService.config.baseHref}/login`;
    this.loaderService.hide();
    if (authenticated) {
      await this.oktaAuth.logout(loginUrl);
    } else {
      this.loginAuth();
    }
  }
  ActivityOnLogout() {
    if (IsTrue(sessionStorage.isUser)) {
      localStorage.clear();
      sessionStorage.clear();
      this.alertService.success('You have successfully logged out');
    }
  }
  loginAuth() {
    this.ActivityOnLogout();
    this.oktaSignIn = new OktaSignIn({
      baseUrl: getBaseUrl((this.config as OktaConfig2).baseUrl),
      username: '',
      processCreds: (creds, callback) => {
        this.loaderService.show();
        const dataCall: OktaLoginRequest = {
          username: creds.username,
          password: creds.password
        };

        this.oktaLoginService.verifyOkta(dataCall).subscribe(
          (data: any) => {
            sessionStorage.setItem('isUser', 'true');
            sessionStorage.setItem('userName', JSON.stringify(data.Username));
            this.checkElementAvailbility();
            if (data.Status === 'SUCCESS') {
              this.loaderService.hide();
              callback();
            } else {
              this.appendError(
                this.loginContentService.errorOktaMsg().signinFailed
              );
              this.loaderService.hide();
            }
          },
          err => {
            this.alertService.error('Something went wrong, please try again');
            this.appendError(
              this.loginContentService.errorOktaMsg().signinFailed
            );
            console.log(err);
            this.loaderService.hide();
          }
        );
      },
      features: {
        rememberMe: true,
        showPasswordToggleOnSignInPage: false,
        placeholder: true
      },
      helpLinks: {
        forgotPassword: this.getForgotPassword(),
        help: '#'
      },
      language: 'en',
      i18n: {
        en: this.loginContentService.oktaConfiguration()
      }
    });

    this.oktaSignIn.renderEl(
      { el: '#okta-signin-container' },
      res => {
        if (res.status === 'SUCCESS') {
          sessionStorage.setItem('UserId', res.user.profile.login);
          this.processOkta(res);
        }
      },
      err => {
        this.loaderService.hide();
        //throw err;
        this.alertService.error('Please check your username and password and try again.');
      }
    );
  }

  processOkta(res) {
    const dataCall: OktaLoginRequest = {
      id: res.user.id,
      username: res.user.profile.login
    };

    this.oktaLoginService.processOkta(dataCall).subscribe(
      (data: any) => {
        this.globalVariables.sessionId = data.Token;
        this.token = data.Token;
        this.loginOkta(res, data);
      },
      err => {
        this.loaderService.hide();
        //throw err;
        this.alertService.error('Please check your username and password and try again.');
      }
    );
  }

  loginOkta(res, data) {
    const dataCall: OktaLoginRequest = {
      username: res.user.profile.login,
      token: data.Token
    };

    this.oktaLoginService.loginOkta(dataCall).subscribe(
      (data: any) => {
        sessionStorage.setItem('userDetails', JSON.stringify(data));
        sessionStorage.setItem('agentDetails', JSON.stringify(data.AgentInfo));
        this.appDataService.changeStorage.next(data);
        sessionStorage.setItem('token', data.token);
        sessionStorage.setItem('show-boostai', data.BoostFeatureEnabled); 
        sessionStorage.setItem('isWrittenCommissionDisplayApplicable', data.IsKraftLake?'N':'Y');       
        let windowObj=window as any;
        if(data.BoostFeatureEnabled==false){
            
            if(windowObj.hideBoostAI){
              windowObj.hideBoostAI();
              windowObj.showSalesForceChat();
            }
            
           }
           else if(windowObj.showBoostAI)
           {

              windowObj.showBoostAI();
           }
        // const dataCallFeature: userFeatureRequest = {
           
        //   UserName:dataCall.username,
           
        // };
        // this.oktaLoginService.showBoostaiChatSessionId(dataCall.username).subscribe((chatd:any)=>{
        //   sessionStorage.setItem('show-boostai', chatd.BoostFeatureEnabled);
        //   let windowObj=window as any;
        //   if(chatd.BoostFeatureEnabled==false)
        //     windowObj.hideBoostAI();
        // })
        const redirectUrl = appendRelativePathToUrl(
          this.baseUri,
          sessionStorage.getItem('okta-app-url') || '/'
        );
        res.session.setCookieAndRedirect(redirectUrl);
      },
      err => {
        this.loaderService.hide();
        //throw err;
        this.alertService.error('Please check your username and password and try again.');
      }
    );
  }

  openModal(errmsg, username) {
    this.modalContent.data = {
      para: errmsg,
      showFooterBtn: true,
      footerBtnLabel: 'Accept',
      footerBtnCallback: this.callback.bind(this, username)
    };
    this.dialogService.open(CustomModalComponent, this.modalContent);
  }

  resetPasswordModal() {
    this.dialogService.open(
      ResetPasswordComponent,
      this.resetPasswordModalContent
    );
  }

  checkWidgetLoad(id) {
    if ($('#' + id).is(':visible')) {
      return true;
    }
  }

  getForgotPassword() {
    if (this.checkWidgetLoad('okta-signin-container')) {
      setTimeout(() => {
        const content = window.document.getElementById('help-links-container');
        if (!content) return;
        const listItem = content.firstElementChild;
        const newItem = document.createElement('li');
        newItem.innerHTML =
          '<a href="javascript:void(0)" id="forgetPassword" class="ls-modal link">Forgot Your Password?</a>';
        listItem.parentNode.replaceChild(newItem, listItem);

        document
          .getElementById('forgetPassword')
          .addEventListener('click', () => {
            this.forgetPasswordModal();
          });
      }, 300);
    }
  }

  forgetPasswordModal() {
    this.dialogService.open(
      ForgetPasswordComponent,
      this.forgetPasswordModalContent
    );
  }

  callback(username) {
    if (username) {
      (<any>window).location = this.config.issuer + 'login?uid=' + username;
      this.dialogService.close();
    }
  }

  appendError(errorMessage) {
    const oktaErrorContainer = $('div[data-se=o-form-error-container]');
    if (!oktaErrorContainer.hasClass('o-form-has-errors')) {
      oktaErrorContainer.addClass('o-form-has-errors');
    }
    oktaErrorContainer.append(
      '<div><div class="okta-form-infobox-error infobox infobox-error" role="alert"><span class="icon error-16"></span><p>' +
        errorMessage +
        '</p></div></div>'
    );
  }

  /** Custom Okta Login Fields */
  customSignInField() {
    const userName = document.getElementsByClassName(
      'o-form-input-name-username'
    );
    if (!userName || !userName.length) return;
    const userNameValue = (<any>userName[0]).querySelector('input').value;
    userName[0].innerHTML =
      '<span data-toggle="tooltip" title="Enter email address to login" class="input-tooltip icon form-help-16" data-hasqtip="0" aria-describedby="qtip-0"></span><span class="icon input-icon person-16-gray"></span><input type="text" placeholder="Email Address" name="Email" id="okta-signin-username" value="' +
      userNameValue +
      '" aria-label="User ID" autocomplete="off">';

    const password = document.getElementsByClassName(
      'o-form-input-name-password'
    );
    password[0].innerHTML =
      '<span data-toggle="tooltip" title="Enter a password" class="input-tooltip icon form-help-16" data-hasqtip="1"></span><span class="icon input-icon remote-lock-16"></span><input type="password" placeholder="Password" placement="top" ngbTooltip="Enter a password" name="Password" id="okta-signin-password" value="" aria-label="User ID" autocomplete="off">';

    if ($('[data-toggle="tooltip"]').tooltip()) {
      $('[data-toggle="tooltip"]').tooltip();
    }
  }

  ngOnDestroy() {
    if (this.oktaSignIn) this.oktaSignIn.remove();
  }
}
